import noExtendedTagging from "../scoringType/noExtendedTagging.js";
import sessionCouldHaveNewScoringData from "../sessionContents/sessionCouldHaveNewScoringData.js";
import gameOrScrimmageSessionType from "../sessionType/gameOrScrimmage.js";
import sessionClassifierBuilder from "./sessionClassifierBuilder.js";

const sessionWithStatGrabScoring = sessionClassifierBuilder(
    // NOTE - if there is no scoringType specified, we assume it is StatGrab scoring Type
    gameOrScrimmageSessionType, sessionCouldHaveNewScoringData, undefined, noExtendedTagging
);

export default sessionWithStatGrabScoring;